import styled from 'styled-components'

export const ActionButton = styled.div`
    font-family: ${props => props.theme.font};
    font-size: 14px;
    background-color:#000E40;
    color: ${props => props.theme.box.textButton};
    text-align:center;
    font-weight: 700;
    cursor: pointer;
    transition: bottom 0.3s;
    display: inline-block;
    border-radius:4px;
    margin-right:8px;
    margin-bottom:8px;
    padding: 8px;
    line-height: 115%;
`
export const LinkButton = styled.a`
    color:#FFF;
    text-decoration:none;
`
export const BackButton = styled.div`
    font-family: ${props => props.theme.font};
    font-size: 14px;
    background-color:#FFFFFF;
    color:#000E40;
    text-align:center;
    font-weight: 700;
    cursor: pointer;
    transition: bottom 0.3s;
    display: inline-block;
    border-radius:4px;
    border: 1px solid #000E40;
    margin-right:8px;
    margin-bottom:8px;
    padding: 8px;
    line-height: 115%;
`